import { SvgIcon } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const AnnouncerIcon = ({ color = 'black', fontSize = undefined }) => (
    <SvgIcon style={{ fontSize }}>
        <svg
            color={color}
            id="Capa_1"
            version="1.1"
            viewBox="0 0 36 36"
            x="0px"
            xmlns="http://www.w3.org/2000/svg"
            y="0px"
        >
            <path
                id="XMLID_2_"
                className="st0"
                d="M4.5,23.9h4.4L11,9c0,0,1.6-1.9,2.4,0.4l-1.9,14.5h21L30.5,8c0,0-0.7-4.5-5.1-4.5s-13.8,0-13.8,0
	s-4.4-0.3-5,4.5S4.5,23.9,4.5,23.9z"
            />
            <path
                id="XMLID_3_"
                className="st0"
                d="M32.9,32.6H3.1c-1.5,0-2.8-1.2-2.8-2.8v-2.3c0-1.5,1.2-2.8,2.8-2.8h29.9c1.5,0,2.8,1.2,2.8,2.8
	v2.3C35.7,31.4,34.5,32.6,32.9,32.6z"
            />
        </svg>
    </SvgIcon>
);

AnnouncerIcon.propTypes = {
    color: PropTypes.string,
    fontSize: PropTypes.string,
};

export default AnnouncerIcon;
